/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchActivityGetInternalV2} from '../api'

export const useMutationBatchActivityGetInternalV2 = createReactQueryMutationHook('batchActivityGetInternalV2', batchActivityGetInternalV2)
